<template>
    <v-col cols="12" md="6" sm="12" xs="12">
        <v-text-field
            v-model="form.copier.copier_quantity"
            type="number"
            density="compact"
            variant="outlined"
            label="How many mailing equipment do you need?">
        </v-text-field>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
